module.exports = carrosselItems = [{
        title: 'Nome da organização',
        description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ',
        image: 'images/spotify.png',
        image_mobile: 'images/spotify.png',
        href: './quem-somos',
        tags: [
            'Saúde',
            'idosos',
            'Esportes'
        ]
    },
    {
        title: 'Nome da organização',
        description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut',
        image: 'images/spotify.png',
        image_mobile: 'images/spotify.png',
        href: './quem-somos',
        tags: [
            'Saúde',
            'idosos',
            'Esportes'
        ]
    },
    {
        title: 'Nome da organização',
        description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut',
        image: 'images/spotify.png',
        image_mobile: 'images/spotify.png',
        href: './quem-somos',
        tags: [
            'Saúde',
            'idosos',
            'Esportes'
        ]
    },
    {
        title: 'Nome da organização',
        description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut.',
        image: 'images/spotify.png',
        image_mobile: 'images/spotify.png',
        href: './quem-somos',
        tags: [
            'Saúde',
            'idosos',
            'Esportes'
        ]
    },
]
